import { PureComponent } from 'react'
// import { EvaluationPerformSingleTable } from './EvaluationPerformSingleTable'
import EvaluationPerformSingleTableCollapsible from './EvaluationPerformSingleTableCollapsible'
import { BarChartSingle } from '../BarCharts/BarChartSingle'
import { BarChartStacked } from '../BarCharts/BarChartStacked';

export class EvaluationPerformSingle extends PureComponent {
    
    evalResult = this.props.callbackPerformSingleEval(this.props.parentState);
    // dummyVar = this.props.callbackSetStausExams("unchanged");

    render() {
        return (
            <>
                <BarChartSingle evalData={this.evalResult}
                    parentState={this.props.parentState} />
                <hr id="hrSpacer" />
                <BarChartStacked evalData={this.evalResult}
                    parentState={this.props.parentState}
                />
                {/* <hr id="hrSpacer" />
                <EvaluationPerformSingleTable
                    evalData={this.evalResult}
                    parentState={this.props.parentState}
                    callbackToggleShowHideCrossProduct={this.props.callbackToggleShowHideCrossProduct}
                    callbackToggleShowHideDetailsTable={this.props.callbackToggleShowHideDetailsTable}
                /> */}
                <hr id="hrSpacer" />
                <EvaluationPerformSingleTableCollapsible
                    evalData={this.evalResult}
                    parentState={this.props.parentState}
                />
            </>
        )
    }
}